import { render, staticRenderFns } from "./MiniSelect.vue?vue&type=template&id=6c8a4492&scoped=true&"
import script from "./MiniSelect.vue?vue&type=script&lang=js&"
export * from "./MiniSelect.vue?vue&type=script&lang=js&"
import style0 from "./MiniSelect.vue?vue&type=style&index=0&id=6c8a4492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a4492",
  null
  
)

export default component.exports